/** Small document illustrations share Performance's paper, ink and accent.
 * The connector shows the idea, not a claimed chronological event history. */
export function MilestoneArt({ kind }: { kind: number }) {
  return (
    <svg viewBox="0 0 100 76" aria-hidden="true" className="ld-milestone-art">
      <path className="ld-art-orbit" d="M8 62 Q50 76 92 62" />
      {kind === 0 && (
        <>
          <rect
            className="ld-paper"
            x="28"
            y="8"
            width="43"
            height="55"
            rx="5"
            transform="rotate(-7 50 36)"
          />
          <path className="ld-ink" d="M38 23h22M38 30h16M38 37h19" />
          <circle className="ld-art-fill" cx="63" cy="53" r="13" />
          <path className="ld-accent" d="m56 53 5 5 9-10" />
        </>
      )}
      {kind === 1 && (
        <>
          {[14, 38, 62].map((x, index) => (
            <g key={x} transform={`translate(${x} ${index === 1 ? 8 : 19})`}>
              <rect className="ld-paper" width="26" height="41" rx="4" />
              <path className="ld-ink" d="M6 9h14M6 16h10M6 23h14" />
              <path className="ld-accent" d="M6 31h9" />
            </g>
          ))}
        </>
      )}
      {kind === 2 && (
        <>
          <path className="ld-paper" d="M41 8h18v22l20 29q4 8-6 8H27q-10-1-6-8l20-29Z" />
          <path className="ld-accent" d="M35 8h30M33 46h35M41 8v22M59 8v22" />
          <circle className="ld-art-fill" cx="44" cy="53" r="4" />
          <circle className="ld-art-fill" cx="58" cy="58" r="3" />
        </>
      )}
      {kind === 3 && (
        <>
          <path className="ld-accent" d="M50 35 22 18M50 35l28-17M50 35 22 60M50 35l28 25" />
          {[
            [50, 35],
            [22, 18],
            [78, 18],
            [22, 60],
            [78, 60],
          ].map(([x, y], index) => (
            <g key={index}>
              <circle className="ld-paper" cx={x} cy={y} r={index ? 10 : 15} />
              <path className="ld-accent" d={`m${x - 4} ${y} 3 3 5-6`} />
            </g>
          ))}
        </>
      )}
      {kind === 4 && (
        <>
          <rect className="ld-paper" x="19" y="13" width="40" height="51" rx="4" />
          <path className="ld-ink" d="M29 26h19M29 34h19M29 42h12" />
          <path className="ld-art-fill" d="m65 25 17 7v14q0 13-17 20-17-7-17-20V32Z" />
          <path className="ld-accent" d="m57 45 6 6 10-13" />
        </>
      )}
      {kind === 5 && (
        <>
          <rect className="ld-paper" x="22" y="11" width="39" height="51" rx="4" />
          <path className="ld-ink" d="M31 23h18M31 31h18M31 39h12" />
          <path className="ld-art-fill" d="m67 22-16 24h13l-6 20 23-28H67l6-16Z" />
          <path className="ld-accent" d="M7 29h10M4 39h13M7 49h10" />
        </>
      )}
    </svg>
  );
}
